import React, { useState, useEffect, use } from "react";
import FormContainer from "../../../shared/components/FormContainer/FormContainer";
import { RECHARGE_TYPE } from "../../../enums/recharge-type.enum";
import BundleTable from "../../../shared/components/BundleTable";
import { fetchConfiguration } from "../../../shared/service";
import { useNavigate } from "react-router-dom";
import "./Prepaid.scss";
import { useLoading } from "../../../../../Shared/cache/context/LoadingProvider";
import ToastMsg from "../../../shared/components/ToastMsg/ToastMsg";
import { eventEmitter, getEventName } from "../../../../../Shared/service/google-analytics.service";
import { sendGA4Event } from "../../../../../Shared/helper/google-analytics";
import { ORP_TRANSLATION, TRANSLATION, GET, LANGUAGE_PREFIX } from "../../../../../Shared/helper/constants";
import useFetch from "../../../../../Shared/cache/useFetch";
import { useLanguage } from "../../../../../Shared/cache/context/LanguageProvider";
import { AIRTIME_RECHARGE, BUNDLE_PURCHASE, GA, ORP } from "../../../helper/constants";
import { safeJsonParse } from "../../../../../Shared/utils/commonutils";
import { PREPAID_ROUTE } from "../../../../../app/routes/routeConstant";
import { allowNewThemeRedirection } from "../../../../../Shared/helper/helper";

const Prepaid = () => {
  const [formData, setFormData] = useState({ msisdn: "", amount: "" });
  const [lineTypeRes, setLineType] = useState(false);
  const [msisdnLineType, setmsisdnLineType] = useState("");
  const [maxAmount, setmaxAmount] = useState("");
  const [minAmount, setminAmount] = useState("");
  const [inputText, setinputText] = useState("");
  const [minError, setMinError] = useState("");
  const [maxError, setMaxError] = useState("");
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoading();
  const [toastMsg, setToastMsg] = useState(null);
  const [lineTypeData, setLineTypeData] = useState();
  const [msidnError, setMsidnError] = useState('');
  const [translation, setTranslation] = useState({
    onlineRecharge: 'Online Recharge',
    buyAirtime: 'BUY AIRTIME'
  })
  const { languagePrefix, selectedLanguage } = useLanguage();
  const { data: data, refetch } = useFetch({
    url: ORP_TRANSLATION.replace(LANGUAGE_PREFIX, languagePrefix),
    method: GET,
    key: TRANSLATION,
    cache: {
      enabled: true,
      ttl: 3600
    },
    initialEnabled: false,

  });
  const [eventEmittedFields, setEventEmittedFields] = useState(new Set());


  useEffect(() => {
    if (data?.prepaid) {
      setTranslation(data?.prepaid)
    }
  }, [data])

  useEffect(() => {
    const cachedData = sessionStorage.getItem(`${TRANSLATION}_${selectedLanguage}`);
    if (!cachedData) {
      refetch(true);
    } else {
      refetch(false)
    }
  }, [selectedLanguage]);

  const handleChange = (e) => {
    const { name, value = '' } = e.target;
    setFormData({ ...formData, [name]: e.target.value });
    if (formData.amount && formData.amount < Number(minAmount)) {
      setMinError("Minimum amount should be");
    } else if (formData.amount && formData.amount > Number(maxAmount)) {
      setMaxError("Maximum amount should be");
    } else {
      setMinError("");
      setMaxError("");
      // setLineTypeData("");
    }
    if (value.length == process.env.REACT_APP_NUMBER_MAX_LENGTH) {
      eventEmitter(ORP, `${name}_entered`, 'page load', `${name}_entered`, null)
      eventEmitter(ORP, `prepaid_${name}_entered`, 'page load', `prepaid_${name}_entered`, null)
    }
  };

  useEffect(() => {
    let widgetInfo = sessionStorage.getItem("widgetInfo");
    widgetInfo = safeJsonParse(widgetInfo);
    if ((widgetInfo?.type)?.toLowerCase() == "prepaid") {
      setFormData({ ...formData, msisdn: widgetInfo?.msisdn })
    }
    fetchConfig();
    eventEmitter(ORP, 'pay_recharge_prepaid_page', 'page load', 'pay_recharge_prepaid_page', null);
  }, []);

  const showToastMsg = (type, message) => {
    setToastMsg({ type, message });
    setTimeout(() => setToastMsg(null), 3000);
  }

  const fetchConfig = () => {
    showLoader();
    fetchConfiguration()
      .then((res) => {
        hideLoader();
        res = res?.data;
        if (
          res &&
          (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
        ) {
          if (allowNewThemeRedirection(res?.result?.configData?.newThemeRedirection?.prepaidRecharge)) {
            return navigate(PREPAID_ROUTE, { replace: true });
          }
          setmaxAmount(res?.result?.configData?.preMaxAmnt);
          setminAmount(res?.result?.configData?.preMinAmnt);
          if (
            res?.result?.configData?.payStackConfig &&
            safeJsonParse(res.result?.configData?.payStackConfig).key
          ) {
            sessionStorage.setItem(
              "_p_y_m_e_n_t_k_e_",
              safeJsonParse(res.result?.configData?.payStackConfig).key,
              true
            );
          }
          if (res.result.configData) {
            sessionStorage.setItem(
              "_c_o_n_f_i_g",
              JSON.stringify(res?.result?.configData),
              true
            );
          }
          // setinputText(res?.result && res.result?.configData['landingPageMessage']['prepaid'] || '')
          eventEmitter(ORP, 'te_prepaid_recharge_fetch_config_success', 'click', 'te_prepaid_recharge_fetch_config_success', null)
        }
        else {
          showToastMsg('Error', res?.message || "Something Went Wrong!")
          eventEmitter(ORP, 'te_prepaid_recharge_fetch_config_failed', 'click', res?.message, null);
        }
      })
      .catch((error) => {
        hideLoader();
        showToastMsg('Error', error?.error?.message || error?.message || "Something Went Wrong!")
        eventEmitter(ORP, 'te_prepaid_recharge_fetch_config_failed', 'click', error?.error?.message, null);
      });
  };

  const buyAirtime = () => {
    let txnData = {
      msisdn:
        process.env.REACT_APP_OPCO.toLowerCase() == GA
          ? "0" + formData.msisdn
          : formData.msisdn,
      enableDualCurrency: process.env.REACT_APP_OPCO.toLowerCase() == "drc" ? true : false,
      amount: formData.amount,
      lineType: "PREPAID",
      transactionType: "PREPAID_RECHARGE",
      productCode: null,
      description: "Recharge Amount",
      currency: process.env.REACT_APP_CURRENCY,
      redirectPage: "/prepaid-recharge",
      rechargeType: RECHARGE_TYPE.PREPAID_RECHARGE,
      theme: "theme-v1",
      flow: ORP,
      template: AIRTIME_RECHARGE
    };
    sessionStorage.setItem("queryData", JSON.stringify(txnData), true);
    navigate("/payment/start", { replaceUrl: true });
    eventEmitter(ORP, getEventName('airtime', 'buy_selected'), 'click', getEventName('airtime', 'buy_selected'), null);
  };

  const handleLineTypeData = (data) => {
    setLineTypeData(data);
    if (data?.result != "PREPAID" && data?.result != "HYBRID") {
      setMsidnError('Invalid Mobile No')
    } else {
      setMsidnError('')
    }
  }

  const crossClick = () => {
    setFormData({ ...formData, msisdn: "" });
    setLineType(false);
  };
  const handleDataForm = (data) => {
    setLineType(data);
    setmsisdnLineType("PREPAID");
  };
  const onPackSelect = (event, bundleInfo) => {
    // event.persist();
    if (!bundleInfo) {
      return;
    }

    setFormData({ ...formData, amount: bundleInfo?.amount?.toString() });
    let txnData = {
      msisdn:
        process.env.REACT_APP_OPCO?.toLowerCase() == GA
          ? "0" + formData?.msisdn
          : formData?.msisdn,
      enableDualCurrency: process.env.REACT_APP_OPCO?.toLowerCase() == "drc" ? true : false,
      amount: bundleInfo?.amount,
      bundleInfo: bundleInfo,
      lineType: bundleInfo?.linetype || "PREPAID",
      productCode: bundleInfo?.productCode,
      description: "Bundle Purchase",
      currency: bundleInfo?.currency || process.env.REACT_APP_CURRENCY,
      redirectPage: "/prepaid-recharge",
      rechargeType: "BUNDLE PURCHASE",
      transactionType:
        (bundleInfo?.lineType || msisdnLineType).toLowerCase() == "prepaid"
          ? "PREPAID_BUNDLES"
          : "POSTPAID_BUNDLES",
      flow: ORP,
      template: BUNDLE_PURCHASE
    };
    sessionStorage.setItem("queryData", JSON.stringify(txnData), true);

    navigate("/payment/start");
    eventEmitter(ORP, getEventName('bndl', 'buy_selected_prepaid'), 'click', getEventName('bndl', 'buy_selected_prepaid'), null);;

  };
  return (
    <>
      <div className="online-recharge">
        <div className="container">
          <h2>{translation?.onlineRecharge}</h2>
        </div>
      </div>
      <div className="bundle-recharge-form">
        <div className="container">
          <div className="form-container">
            <FormContainer
              formInput={formData}
              handleChange={handleChange}
              crossClick={crossClick}
              sendDataToParent={handleDataForm}
              maxAmount={maxAmount}
              minAmount={minAmount}
              minError={minError}
              maxError={maxError}
              sendLineTypeData={handleLineTypeData}
              msidnError={msidnError}
            ></FormContainer>
            <button className="buyAirtimeBtn" disabled={(!formData.msisdn || !formData?.amount || minError || maxError || (lineTypeData?.result != "PREPAID" && lineTypeData?.result != "HYBRID"))} onClick={buyAirtime}>{translation?.buyAirtime}</button>

          </div>
        </div>
      </div>


      {(lineTypeRes && lineTypeData?.result == "PREPAID") && (
        <BundleTable
          msisdn={formData?.msisdn}
          linetype={msisdnLineType}
          buyBundleEvent={onPackSelect}
        />
      )}
      {toastMsg && <ToastMsg message={toastMsg.message} type={toastMsg.type} onClose={() => setToastMsg(null)}></ToastMsg>}
    </>
  );
};

export default Prepaid;
